import * as D from './deps';
import VolumeReducer, { VolumeFilter } from './reducer';

export default D.createDomainModule({
  name: 'volume',
  components: null,
  reducer: VolumeReducer,
  persisted: true,
  persistTransforms: [VolumeFilter],
  onStart() {},
  onStop() {},
});
